import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { startLogin } from '../../actions/auth';
import MemoryChargedLoginForm from './MemoryChargedLoginForm';
import MemoryChargedSendEmailForm from './MemoryChargedSendEmailForm';
import { reset } from '../../api/api';
import { pushToDataLayer } from '../../utils/gtmUtils';

export class MemoryChargedLoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayForm: 'login',
      displayNewPasswordForm: false,
      validSendEmail: false,
      title: 'Se Connecter',
      spinner: 'inactive',
      sendEmailSpinner: 'inactive',
      errorSendEmailMessage: '',
      pathName: props.location.pathname,
      messageLogin: {
        display: false,
        text: '',
      }
    }
    this.onCLickForgotPassword = this.onCLickForgotPassword.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.messages !== this.props.messages) {
      this.setState({
        messageLogin: this.props.messages.login
      });
    }
  }


  onCLickForgotPassword() {
    this.setState({ displayForm: 'email', title: 'Modifier le mot de passe' });
  }
  onSubmit = (credentials) => {

    const dataLayer = {
        event: "login",
        url: window.location.href,
        user: credentials.userName,
        idPartenaire: this.props.partenaireData.id
    }
    pushToDataLayer(dataLayer);

    this.setState({ spinner: 'active' })
    this.props.startLogin(credentials)
    setTimeout(() => { this.setState({ spinner: 'inactive' }) }, 500);
  };
  sendEmail = (data) => {
    const dataLayer = {
      event: "resetPassword",
      url: window.location.href,
      idPartenaire: this.props.partenaireData.id
    }
    pushToDataLayer(dataLayer);
    this.setState({ sendEmailSpinner: 'active' });
    reset(data).then(() => {
      setTimeout(() => { this.setState({ sendEmailSpinner: 'inactive' }) }, 500);
      this.setState({ validSendEmail: true, errorSendEmailMessage: '' });
    }, error => {
      this.setState({ errorSendEmailMessage: 'E-mail incorrect ' });
      setTimeout(() => { this.setState({ sendEmailSpinner: 'inactive' }) }, 500);
      console.log(error);
    })

  }

  render() {
    return (
      <div className="login-main">
        <div className="page-background"></div>
        <div className="container login-container">
          <div className="bloc-form">
            <h2>{this.state.title}</h2>
            {this.state.displayForm === 'login' &&
              <MemoryChargedLoginForm
                onSubmit={this.onSubmit}
                onCLickForgotPassword={this.onCLickForgotPassword}
                spinner={this.state.spinner}
                pathName={this.state.pathName}
              />
            }
            {this.state.displayForm === 'email' &&
              <div>
                {!this.state.validSendEmail ?
                  <MemoryChargedSendEmailForm
                    sendEmail={this.sendEmail}
                    spinner={this.state.sendEmailSpinner}
                  />
                  :
                  <div className="bloc-from_success">
                    <img src='/images/yes.png' alt="image" />
                    <p className="validation-txt">
                      Vous allez recevoir un mail de confirmation avec un lien d’activation de votre espace de recueil de mémoire.
                    </p>
                  </div>
                }
              </div>
            }
            <div className="bloc-form_error">
              {
                this.state.messageLogin.display &&
                <div className="alert alert-danger" >
                  {this.state.messageLogin.text} <br />
                  <span className="small-txt">Accès au site refusé </span>
                </div>
              }
              {this.state.errorSendEmailMessage &&
                <div className="alert alert-danger single-line" role="alert">{this.state.errorSendEmailMessage}</div>
              }
            </div>
          </div>
          <div className="signon-container">
              <div className="col-sm-5 text-bloc">
                <h2>Chargé de mémoire</h2>
                <p className>Afin de visualiser un recueil de mémoire, merci de saisir votre email et votre mot de passe.</p>
              </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  startLogin: (credentials) => dispatch(startLogin(credentials))
});

const mapStateToProps = (state) => ({
  messages: state.messages,
  partenaireData: state.partenaireData
});

export default connect(mapStateToProps, mapDispatchToProps)(MemoryChargedLoginPage);



// WEBPACK FOOTER //
// ./src/components/MemoryChargedLoginPage/MemoryChargedLoginPage.js